/**
 * @generated SignedSource<<dcc47963f81b09c7afc0d08e0064b993>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AHImageStackComponent_Images$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  readonly " $fragmentType": "AHImageStackComponent_Images";
}>;
export type AHImageStackComponent_Images$key = ReadonlyArray<{
  readonly " $data"?: AHImageStackComponent_Images$data;
  readonly " $fragmentSpreads": FragmentRefs<"AHImageStackComponent_Images">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AHImageStackComponent_Images",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Image_image"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "d7197e0b36a91ac71a64c1acc59bbef8";

export default node;
